/**
 * Converts a dash, snake case or pascal case string to camel case.
 *
 * @param  {string} input
 * @return {string}
 */

const camelCase = input => (
    input.match(/[_-]/) ?
        input.replace(/([_-][a-z0-9])/g, $1 => $1.toUpperCase().replace(/[_-]/, '')) :
        input.charAt(0).toLowerCase() + input.slice(1)
);

export default camelCase;
